import { Reveal } from "./Reveal";
import { STEPS } from "@/data/content";

export const HowItWorks = () => (
  <section className="py-24 md:py-32 bg-ink text-bone" data-testid="how-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">How it works</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl">
          Three steps from empty room to closed deal.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-bone/10 border border-bone/10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="h-full bg-ink p-8 md:p-10">
              <div className="font-serif text-7xl md:text-8xl text-coral leading-none">{s.n}</div>
              <h3 className="mt-6 font-serif text-3xl md:text-4xl">{s.title}</h3>
              <p className="mt-4 text-sm md:text-base text-bone/60 leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <a
          href="/preview/demo"
          data-testid="how-demo-link"
          className="mt-10 inline-flex items-center gap-2 text-coral hover:text-bone transition-colors text-sm border-b border-coral/40 pb-1"
        >
          Try the interactive demo listing →
        </a>
      </Reveal>
    </div>
  </section>
);
